import { ProgressRing, ProgressRingPlaceholder, Text } from './styled';

const STROKE_WIDTH = 6;
const ROTATION_OFFSET = 15;
const ARC_ANGLE = 360 - 2 * ROTATION_OFFSET;

function TabWidget({
  progress = 0,
  size = 100,
  strokeWidth = STROKE_WIDTH,
  total = '5.00',
}: any) {
  const r = getRadius(size, strokeWidth);
  const c = getCenterCoordinates(size);
  const circumference = getCircumference(r);
  const arcLength = getArcLength(r);
  const strokeDashoffset = getStrokeDashoffset(
    arcLength,
    circumference,
    Math.min(progress, 100)
  );
  const placeholderStrokeDashoffset = circumference - arcLength;

  return (
    <svg height={size} width={size}>
      <ProgressRing
        strokeDasharray={`${circumference} ${circumference}`}
        strokeDashoffset={strokeDashoffset}
        strokeWidth={strokeWidth}
        r={r}
        cx={c}
        cy={c}
        style={{ transform: `rotate(${90 + ROTATION_OFFSET}deg)` }}
      />
      <ProgressRingPlaceholder
        strokeDasharray={`${circumference} ${circumference}`}
        strokeDashoffset={placeholderStrokeDashoffset}
        strokeWidth={STROKE_WIDTH}
        r={r}
        cx={c}
        cy={c}
        style={{ transform: `rotate(${90 + ROTATION_OFFSET}deg)` }}
      />
      <Text x='50%' y='50%' dominantBaseline='middle' textAnchor='middle'>
        {total}
      </Text>
    </svg>
  );
}

function getRadius(size: number, strokeWidth: number) {
  return size / 2 - strokeWidth * 2;
}

function getCenterCoordinates(size: number) {
  return size / 2;
}

function getArcLength(radius: number) {
  return ARC_ANGLE * (Math.PI / 180) * radius;
}

function getCircumference(radius: number) {
  return 2 * radius * Math.PI;
}

function getStrokeDashoffset(
  arcLength: number,
  circumference: number,
  progress: number
) {
  return circumference - (progress / 100) * arcLength;
}

export { TabWidget };
